import SocialMediaAccounts from "./SocialMediaAccounts";

export default SocialMediaAccounts;
